import React from 'react'
import assets from 'xui/assets'
import CommonLogo, { ICommonLogoOptionalProps } from './CommonLogo'

// const LOGO = require('../img/packge_tag/trial.png')
const LOGO = assets.images.packgeTag.trial

const TrialPackageTag = (props: ICommonLogoOptionalProps) => <CommonLogo source={LOGO} {...props} />

export default TrialPackageTag
